import { render } from "./AssociarConjuntoUsuariosVale.vue?vue&type=template&id=a363cd6a&scoped=true"
import script from "./AssociarConjuntoUsuariosVale.vue?vue&type=script&lang=js"
export * from "./AssociarConjuntoUsuariosVale.vue?vue&type=script&lang=js"

import "./AssociarConjuntoUsuariosVale.vue?vue&type=style&index=0&id=a363cd6a&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a363cd6a"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import QTabPanels from 'quasar/src/components/tab-panels/QTabPanels.js';
import QTabPanel from 'quasar/src/components/tab-panels/QTabPanel.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QTabs,QTab,QTabPanels,QTabPanel,QTable,QTd,QBtn});
